import { View } from "react-native";
import { RadioGroupItem } from "./radio-group";
import { Label } from "./label";

export function RadioGroupItemWithLabel({
  value,
  onLabelPress,
  label,
}: {
  value: string;
  onLabelPress: () => void;
  label: string;
}) {
  return (
    <View className={'flex-row gap-2 items-center'}>
      <RadioGroupItem aria-labelledby={`label-for-${value}`} value={value} />
      <Label nativeID={`label-for-${value}`} onPress={onLabelPress}>
        {label}
      </Label>
    </View>
  );
}